import styled from "styled-components";


export const MobileTerminalShell = styled.div`
    background-color: white;
    position: relative;
    z-index: 1;
    color: black;
    max-width: 100%;
    text-wrap: wrap;
    width: 100%;
    display: flex;
    flex-grow: 1;
    height: 100%;
    flex-direction: column;
    font-family: "Fira Code", monospace;
`


export const TerminalShell = styled.div`
    background-color: white;
    position: relative;
    z-index: 1;
    color: black;
    max-width: 100%;
    text-wrap: wrap;
    height: 100%;
    display: flex;

    flex-direction: column;
    font-family: "Fira Code", monospace;
`;

// should extend when user types further
// width should be 100% - the space filled by the pre tag
// I removed this 
// border: gray 1px solid;
// border-radius: 5px;
export const ConsoleInput = styled.input`
  background-color: white;
  color: black;
  flex: 1;
  flex-grow:1;
  margin: 0;
  font-size: 1em;
  &:focus {
    outline: none;
  }
`;

export const TerminalPre = styled.pre`
  text-wrap: wrap;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
  word-break: break-all;
  color: black;
  background-color: white;
  font-family: "Fira Code", monospace;
  max-width: 100%;
  max-height: 100%;
  line-height: 1.2em;
  padding-left:10px;
  padding-right:10px;
  min-height: 0;      /* This is important */
  flex-grow: 1;
`;